var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChatPlayTts = function SvgIconChatPlayTts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "#fff",
    stroke: "#242526"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 7.654a.4.4 0 0 1 0 .692l-4.8 2.772a.4.4 0 0 1-.6-.347V5.23a.4.4 0 0 1 .6-.347l4.8 2.772Z",
    fill: "#242526"
  })));
};
export default SvgIconChatPlayTts;